import HotelApi from '@customTypes/hotel-api';
import HotelDetails from '@customTypes/hotel-details';

export function isValidHttpUrl(string: string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}

export const removeDuplicates = (allHotels: HotelApi[]) => {
  const duplicatesRemovedHotels: HotelApi[] = [];
  if (allHotels.length > 0) {
    const hotelIds: number[] = [];
    allHotels.forEach((hotel: HotelApi) => {
      if (hotelIds.indexOf(hotel.id) === -1) {
        duplicatesRemovedHotels.push(hotel);
        hotelIds.push(hotel.id);
      }
    });
  }
  return duplicatesRemovedHotels;
};

export const sortHotels = (hotelsData: HotelDetails[], hotelIds: string[]) => {
  // Sort hotelsData based on the order of hotelIds
  const sortedHotels = Object.values(hotelsData).sort((a, b) => {
    const indexA = hotelIds.findIndex((id) => id === a.id.toString());
    const indexB = hotelIds.findIndex((id) => id === b.id.toString());
    return indexA - indexB;
  });
  return sortedHotels;
};
